import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import GLMasterSequenceService from "services/Setup/Jurnal/GLMasterSequenceService";

export const initialState = {
  loading: false,
  error: null,
  glMasterSequenceByType: {},
};

const toListAndCount = (response) => {
  const payload = response?.data;
  if (payload && Array.isArray(payload.data)) {
    return { list: payload.data, count: payload.count ?? payload.data.length };
  }
  if (Array.isArray(payload)) return { list: payload, count: payload.length };
  return { list: [], count: 0 };
};

export const getGLMasterSequenceList = createAsyncThunk(
  "glMasterSequence/getGLMasterSequenceList",
  async (params = {}, { rejectWithValue }) => {
    try {
      const response = await GLMasterSequenceService.getGLMasterSequenceList(params);
      const { list, count } = toListAndCount(response);
      return { key: params.journalTypeId, list, count };
    } catch (error) {
      return rejectWithValue({ key: params.journalTypeId, error });
    }
  }
);

const GLMasterSequenceSlice = createSlice({
  name: "glMasterSequence",
  initialState,
  reducers: {
    clearGLMasterSequence: (state) => {
      state.glMasterSequenceByType = {};
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getGLMasterSequenceList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getGLMasterSequenceList.fulfilled, (state, action) => {
        state.loading = false;
        state.glMasterSequenceByType[action.payload.key] = action.payload.list;
      })
      .addCase(getGLMasterSequenceList.rejected, (state, action) => {
        state.loading = false;
        state.error = "Gagal memuat GL master sequence";
      });
  },
});

export const { clearGLMasterSequence } = GLMasterSequenceSlice.actions;

export default GLMasterSequenceSlice.reducer;
